import { addDays, set } from 'date-fns'
import { Filter } from '../common/types/calendar'
import { getPrevDateByDay } from '../common/utils/date'
import { Conditions } from './fetchSchedules'

function getConditions(date: Date, filtered: Filter[]): Conditions {
  const from = set(
    getPrevDateByDay(date, 'sunday'), 
    { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }
  )
  const conditions: Conditions = {
    equipment_ids: filtered.map((filter) => filter.id),
    from: from,
    to: addDays(from, 7),
  }

  return conditions
}

export default getConditions
